import { useCallback, useState } from "react";
import toastError from "../../errors/toastError";

export function useLocalStorage(key, initialValue) {
	const [storedValue, setStoredValue] = useState(() => {
		try {
			const item = localStorage.getItem(key);
			return item ? JSON.parse(item) : initialValue;
		} catch (error) {
			toastError(error);
			return initialValue;
		}
	});

	const setValue = useCallback((value) => {
		setStoredValue((prev) => {
			try {
				const valueToStore =
					value instanceof Function ? value(prev) : value;
				localStorage.setItem(key, JSON.stringify(valueToStore));
				return valueToStore;
			} catch (error) {
				toastError(error);
				return prev;
			}
		});
	}, [key]);

	return [storedValue, setValue];
}
